import React, { useState, useRef, useEffect } from 'react';
import { useField } from '@unform/core';

import api from '~/services/api';
import { Container } from './styles';

export default function ImageInput() {
  const { defaultValue, registerField } = useField('cover');
  const [file, setFile] = useState(defaultValue && defaultValue.id);
  const [preview, setPreview] = useState(defaultValue && defaultValue.url);
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      registerField({
        name: 'file_id',
        ref: ref.current,
        path: 'dataset.file',
      });
    }
  }, [ref, registerField]);

  async function handleChange(e) {
    const data = new FormData();

    data.append('file', e.target.files[0]);

    const response = await api.post('/files', data);

    const { id, url } = response.data;

    setFile(id);
    setPreview(url);
  }
  return (
    <Container>
      <label htmlFor="cover">
        <img
          src={
            preview ||
            'https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118928_1280.png'
          }
          alt=""
        />

        <input
          type="file"
          id="cover"
          accept="image/*"
          data-file={file}
          onChange={handleChange}
          ref={ref}
        />
      </label>
    </Container>
  );
}
